import { useMutation } from "react-query";
import { addOfficeBank } from "../../../../../actions/Utilities/OfficeBank";

const useAddOfficeBank = () => {
  return useMutation(addOfficeBank);
};
export default useAddOfficeBank;
